import _ from "lodash";
import React, { useCallback } from "react";
import styled from "styled-components";

import { Flex, Icon } from "@mm/ui";

import "./style.scss";

import { ACTIONS, useFilterProvider } from "../FilterProvider";

import FilterLabelList from "./LabelList";

const ArrowIcon = styled(Icon)({
  color: ({ theme: { colors } }) => colors.brand.primary,
  "::after": {
    // @TODO: Remove important - changes at Icon-component are required
    fontSize: ({ theme: { fontSizes } }) => `${fontSizes[1]}px !important`,
    marginRight: ({ theme: { space } }) => `${space.xs}px`,
  },
});

const SelectedFilters = () => {
  const {
    state: { filters },
    dispatch,
  } = useFilterProvider();

  const resetHandler = useCallback(() => {
    dispatch({ type: ACTIONS.RESET_FILTER });
  }, [dispatch]);

  return _.size(filters) ? (
    <Flex flexWrap="wrap" alignItems="center" mb="xs">
      <FilterLabelList
        filters={filters}
        onClick={(group, name) => {
          dispatch({
            type: ACTIONS.REMOVE_FILTER,
            payload: {
              group,
              name,
            },
          });
        }}
      />
      <button onClick={resetHandler} className="msd-remove-filter-btn">
        <ArrowIcon name="arrow-right" />
        Auswahl zurücksetzen
      </button>
    </Flex>
  ) : null;
};

export default SelectedFilters;
